import React from 'react';
import cls from './DadataList.module.css';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const DadataList = ({ dadataList, dadataHandler }) => {
    const { t } = useTranslation();

    return (
        <div className={classNames(cls.wrapper)}>
            {dadataList.map((item) => (
                <div onClick={() => dadataHandler(item)} className={classNames(cls.item)}>
                    <span className={classNames(cls.title)}>{item.full_name}</span>
                    <span>
                        {t('DadataList.return.INN')}: {item.inn}
                    </span>
                    <span>{item.legal_address}</span>
                </div>
            ))}
        </div>
    );
};
